<template>
  <v-layout>
    <v-dialog v-model="dialog" v-closable="{ exclude: [], handler: 'onClickOutside' }" @keydown.esc="$emit('closeDialog')" max-width="500">
      <v-card>
        <v-card-title>
          <v-layout justify-space-between>
            <span class="headline font-weight-black text-color-title">Download de extrato</span>
            <v-icon class="cursor-type" right @click="$emit('closeDialog')">close</v-icon>
          </v-layout>
          <v-spacer></v-spacer>
          <h4>Conta: {{ `${record.id} - ${record.currency}`}}</h4>
          <h4>Selecione o intervalo desejado:</h4>
        </v-card-title>
        <v-layout>
          <v-flex xs12 md12 lg6 px-2>
            <DefaultFilterDate ref="filterStartDate" @reload="this.reloadStartDate" kind="date" label="Data inicial" />
          </v-flex>
          <v-flex xs12 md12 lg6 px-2>
            <DefaultFilterDate ref="filterEndDate" @reload="this.reloadEndDate" kind="date" label="Data final" :minDate="filterStartDate" />
          </v-flex>
        </v-layout>
        <v-card-text>
          {{ feedbackMsg }}
          <v-layout align-center justify-space-between>
            Formato de saída:
            <v-radio-group v-model="fileType" row>
              <v-radio label="CSV" value="csv"></v-radio>
              <v-radio label="PDF" value="pdf"></v-radio>
            </v-radio-group>
            <v-btn color="#27DABC" depressed :loading="loading" :disabled="!readyToDownload" @click="loadAndDownloadStatement(record, fileType)">
              Baixar
            </v-btn>
          </v-layout>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import utils from "../../shared/Utils"
import Statement from "../../shared/Statement"
import DefaultFilterDate from "../filters/DefaultFilterDate.vue"

export default {
  name: 'StatementDownloadDialog',
  components: { DefaultFilterDate },
  props: {
    record: {
      type: Object,
      default: null
    },
    dialog: {
      type: Boolean,
      default: false
    }
  },
  data(vm) {
    return {
      opening: false,
      loading: false,
      fileType: 'csv',
      feedbackMsg: '',
      filterEndDate: null,
      filterStartDate: null
    }
  },
  watch: {
    dialog (val) {
      if (val == false) {
      } else {
        this.opening = true
        setTimeout(function(){
          this.$nextTick(function () {
            this.opening = false
          })
        }.bind(this), 500)
      }
    },
  },
  methods: {
    reloadStartDate(filter_date) {
      this.filterStartDate = filter_date
    },
    reloadEndDate(filter_date) {
      this.filterEndDate = filter_date
    },
    onCancel(e) {
      this.$emit('closeDialog')
    },
    onClickOutside() {
      this.$emit('closeDialog')
    },
    async loadAndDownloadStatement(bank_account, format) {
      if (this.loading) return

      let balanceValue = await this.getBalance(bank_account.id, this.filterEndDate)

      let successCallback = (response) => {
        let statement = response.body.data
        if (statement) {
          if (statement.length === 0) {
            this.feedbackMsg = 'Nenhum registro encontrado para o intervalo selecionado'
          } else {
            this.feedbackMsg = `Exportados ${statement.length} registros em arquivo ${format}`
            if (format == 'pdf') Statement.exportAndDownloadPdf(statement, bank_account, balanceValue)
            if (format == 'csv') Statement.exportAndDownloadCsv(statement, bank_account)
          }
        } else {
          this.feedbackMsg = 'error'
        }
        this.loading = false
      }

      let errorCallback = (response) => {
        if (response.status === 401) {
          this.feedbackMsg = 'Não autorizado. Faça o login'
        } else {
          this.feedbackMsg = 'Ocorreu um erro, contate o TI'
        }
        this.loading = false
      }

      this.loading = true
      const token = this.$cookies.get('api_token')
      let params = {}

      params.from = utils.filterDateFrom(this.filterStartDate, false).toISOString()
      params.to = utils.filterDateTo(this.filterEndDate, false).toISOString()

      const url = this.$root.urls.admin__company_bank_account_statement.replace('ID', bank_account.id)
      this.$http.get(url, { params: params, headers: { Authorization: `Bearer ${token}` }}).then(successCallback, errorCallback)
    },
    async getBalance(bank_account_id, filterEndDate) {
      let balance_to_send;

      if (filterEndDate) {
        try {
          const token = this.$cookies.get('api_token')
          const url = this.$root.urls.admin__bank_accounts_balance.replace('ID', bank_account_id)
          const formattedDate = new Date(filterEndDate + 'T23:59:59.999Z').toISOString()

          const response = await this.$http.get(url, {
            params: { end_date: formattedDate },
            headers: { Authorization: `Bearer ${token}` }
          })

          if (response.body.data) {
            balance_to_send = !this.hasPreviousPage
              ? response.body.data.balance
              : this.statementBalances[this.statementBalances.length - 1]

            return balance_to_send
          } else {
            this.feedbackMsg = 'Nenhum registro encontrado para o intervalo selecionado'
            return 0
          }
        } catch (error) {
          console.error('Erro ao buscar saldo:', error)
          if (error.status === 401) {
            this.feedbackMsg = 'Não autorizado. Faça o login'
          } else {
            this.feedbackMsg = 'Ocorreu um erro, contate o TI'
          }
          return 0
        }
      } else {
        balance_to_send = !this.hasPreviousPage
          ? this.statementBalance.value
          : this.statementBalances[this.statementBalances.length - 1]

        return balance_to_send
      }
    }
  },
  computed: {
    readyToDownload() {
      return this.filterStartDate && this.filterEndDate
    }
  },
  mounted() {
  },
}
</script>

<style scoped>
  .dark-mode .secondary-btn-bg-color {
  color: white !important;
}
  .statement-dialog {
    /* display: flex; */
    align-items: center;
    background-color: aliceblue;
  }
</style>



// WEBPACK FOOTER //
// src/components/dialogs/StatementDownloadDialog.vue